import { requestWithToken as request } from "./api";

export const downloadObligationsToSheet = (params = {}) =>
    request.post("/download_obligations/?format=json", params);
